export default "__VITE_ASSET__CrQwcZV7__"